import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EquipmentService } from "src/app/equipment/equipment.service";
import { Equipment, EquipmentsEntity } from "src/app/equipment/equipment";
import { Subscription } from "rxjs";
import { ConfirmationDialogComponent } from "src/app/shared/dialoges/confirmation-dialog/confirmation-dialog.component";
import { MatDialog, MatSnackBar } from "@angular/material";

@Component({
  selector: "app-view-equipment",
  templateUrl: "./view-equipment.component.html",
  styleUrls: ["./view-equipment.component.css"],
})
export class ViewEquipmentComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = true;

  equipment: EquipmentsEntity;

  constructor(
    private route: ActivatedRoute,
    private equipmentService: EquipmentService,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {
    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams?.id) {
        this.getEquipmentById(queryParams.id);
      }
    });
  }

  ngOnInit() {}

  /**
   * Get Equipment Details By Id
   */
  getEquipmentById(equipmentId: String | number) {
    this.showLoader = true;
    this.subscription$.add(
      this.equipmentService.getSingleEquipment(equipmentId).subscribe(
        (result: Equipment) => {
          if (result?.Equipment.length) {
            this.equipment = result.Equipment[0];
          }
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Equipment Details. `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * Delete Equipment
   * @param  {String|number} equipment_id
   */
  delete(equipment_id: String | number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "300px",
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.showLoader = true;
        this.subscription$.add(
          this.equipmentService.deleteEquipment(equipment_id).subscribe(
            () => {
              this.router.navigate(["/equipment"]);
              this.showLoader = false;

              this.snackBar.open("Equipment Deleted Sucessfully.", "", {
                duration: 2000,
              });
            },
            (error) => {
              this.showLoader = false;
              this.snackBar.open(`Error in Deleting Equipment. `, "", {
                duration: 2000,
              });
            }
          )
        );
      }
    });
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
